import { getTodaysDayInString } from "../../../utils/DateUtils";
import { CoordinatesInterface } from "../../../config/constants";
import { POLYGON_VIEW_TYPE, SERVICE_TYPE_RECORD_LIST } from "./PlolygonServicesConstants";

export interface PlolygonServicesInitialCountStateInteface {
  serviceTypeList: Array<any>;
  // Map view: the single currently-selected service type (0 or 1 entries)
  serviceTypeFilter: string[];
  // Listing view: service types currently checked in the dropdown (may be ahead of the data actually fetched)
  selectedServiceTypes: Array<string>;
  // Listing view: service types the currently-rendered table data was actually fetched with; drives column visibility
  appliedServiceTypes: Array<string>;
}

export const PlolygonServicesInitialCountState: PlolygonServicesInitialCountStateInteface = {
  serviceTypeList: [...SERVICE_TYPE_RECORD_LIST],
  serviceTypeFilter: [],
  selectedServiceTypes: [],
  appliedServiceTypes: [],
};

export interface MapPolygonOptionInterface {
  fillColor: string;
  fillOpacity: number;
  strokeColor: string;
  strokeOpacity: number;
  strokeWeight: number;
  zIndex: number;
  fillColorCopy: string;
  strokeColorCopy: string;
}
export interface MapPolygonInterface {
  path: Array<CoordinatesInterface> | [];
  options: MapPolygonOptionInterface;
  open: boolean;
  polygonId: string;
  polygonKey: string;
  polygonName: string;
  serviceTypeMapping: MapPolygonServiceTypeMappingInterface;
  posNo: Array<string>;
}

export interface MapPolygonServiceTypeMappingInterface {
  [key: string]: ServiceTypeDetailsInterface[];
}

export interface ServiceTypeDetailsInterface {
  id: number;
  posNo: string | null;
  posName: string | null;
  zoneId: string | null;
  zoneName: string | null;
  status: string | null;
  serviceTypeId: number;
  isServiceable: boolean;
  lastModifiedBy: string;
  lastModifiedAt: string;
}

export interface PlolygonServicesInitialStateInteface {
  loading: boolean;
  overlayLoader: boolean;
  isExporting: boolean;
  // Listing screen
  polygonServiceListData: any;
  page: any;
  size: any;
  maxRecordPresent: any;
  polygonServiceListHeader: any;
  // Action
  editableRowIndex: any;
  // POS Zone
  posZoneSearchText: any;
  posZoneServiceRecord: any;
  posZoneServiceFilteredRecord: any;
  totalRowsCountData: any;
  // POS Zone Pop-up
  serviceTypeName: any;
  showPosZoneMappingPopUp: boolean;
  isNonServiceable: boolean;
  selectedPosZoneIndex: any;
  selectedPosZoneObj: any;
  // Search
  searchTypeValue: any;
  searchValue: any;
  // View
  polygonView: string;
  mapZoom: number;
  mapDefaultCenter: CoordinatesInterface;
  mapCenter: CoordinatesInterface;
  mapMarkersRecord: any;
  mapPolygonsRecord: Array<MapPolygonInterface> | [];
  // Info-Window
  isPosLevelFilteredApplied: boolean;
  posLevelFilterData: MAP_MARKER_INTERFACE | null;
  latSearchValue: number | string;
  lngSearchValue: number | string;
  // Time based filter
  currentTime: any;
  boundaries: any;
  //
  serviceBasedColorRecord: any[];
  day: string;
  openPolygonDetailsPopUp: boolean;
  polygonDetailsPopUpData: PolygonPopUpDetailsInterface;
}

export const PlolygonServicesInitialState: PlolygonServicesInitialStateInteface = {
  loading: false,
  overlayLoader: false,
  isExporting: false,
  // Listing screen
  polygonServiceListData: [],
  page: 1,
  size: 50,
  maxRecordPresent: 0,
  polygonServiceListHeader: {},
  // Action
  editableRowIndex: "",
  // POS Zone
  posZoneSearchText: "",
  posZoneServiceRecord: [],
  posZoneServiceFilteredRecord: [],
  totalRowsCountData: 0,
  // POS Zone Pop-up
  serviceTypeName: "",
  showPosZoneMappingPopUp: false,
  isNonServiceable: false,
  selectedPosZoneIndex: "",
  selectedPosZoneObj: {},
  // Search
  searchTypeValue: "polygonId",
  searchValue: "",
  // View
  polygonView: POLYGON_VIEW_TYPE.LISTING,
  mapZoom: 12,
  mapDefaultCenter: { lat: 0, lng: 0 },
  mapCenter: { lat: 0, lng: 0 },
  mapMarkersRecord: [],
  mapPolygonsRecord: [],
  // Info-Window
  isPosLevelFilteredApplied: false,
  posLevelFilterData: null,
  latSearchValue: "",
  lngSearchValue: "",
  // Time based filter
  currentTime: new Date().setHours(new Date().getHours()), //moment(new Date()).format("HH:mm:ss"),
  boundaries: null,
  //
  serviceBasedColorRecord: [],
  day: getTodaysDayInString(),
  openPolygonDetailsPopUp: false,
  polygonDetailsPopUpData: {
    polygonId: "",
    serviceTypeRecordList: []
  }
};

export const commonPopUpFilterObj: any = {
  openPopUp: false,
  anchorEl: null,
};

export interface PolygonFilterPopUpStateInterface {
  loading: boolean;
  serviceType: any;
  //
  openPopUp: any;
  anchorEl: any;
  //
  posZoneSearchText: any;
  posZoneServiceRecord: any;
  posZoneServiceFilteredRecord: any;
  //
  filterList: any;
}

export const PolygonFilterPopUpInitialState: PolygonFilterPopUpStateInterface = {
  loading: false,
  serviceType: "",
  //
  openPopUp: false,
  anchorEl: null,
  //
  posZoneSearchText: "",
  posZoneServiceRecord: [],
  posZoneServiceFilteredRecord: [],
  //
  filterList: {},
};

export interface PolygonDetailsSideDrawerInterface {
  openDrawer: boolean;
  loading: boolean;
  serviceType: any;
  polygonId: any;
  polygonName: any;
  polygonDetailsHistory: any;
}

export const PolygonDetailsSideDrawerInitialState: PolygonDetailsSideDrawerInterface = {
  openDrawer: false,
  loading: false,
  serviceType: "STANDARD",
  polygonId: "",
  polygonName: "",
  polygonDetailsHistory: [],
};

export interface MAPOPTIONSTYLES_INTERFACE {
  elementType: string;
  featureType?: string;
  stylers: { visibility: string }[];
}
export const mapOptionStyles: MAPOPTIONSTYLES_INTERFACE[] = [
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.land_parcel", elementType: "labels", stylers: [{ visibility: "off" }] },
  { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] },
  { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
];

export interface MAP_MARKER_ICON_INTERFACE {
  url: string;
  scale: number;
  labelOrigin: {
    x: number;
    y: number;
  };
}

export interface MAP_MARKER_LABEL_INTERFACE {
  text: string | number;
  fontSize: string;
  fontWeight: string;
  color: string;
  lineHeight: string;
}
export interface MAP_MARKER_INTERFACE {
  key: string;
  name: string;
  location: CoordinatesInterface;
  icon?: MAP_MARKER_ICON_INTERFACE;
  label?: MAP_MARKER_LABEL_INTERFACE;
  address: any;
  serviceTypes: any;
  selectedServiceDetails: any;
  openWindow: boolean;
  posNo: string | number;
  posName: string;
  visible: boolean;
}

export interface POLYGON_MAP_SERVICE_TYPE_MAPPING_INTERFACE {
  id: number | string;
  posNo: string | number;
  posName: string;
  zoneId: string;
  zoneName: string;
  status: string;
  serviceTypeId: number;
  isServiceable: boolean;
  lastModifiedBy: string | null;
  lastModifiedAt: string | null;
}

export interface AppStateObjInterface {
  loading: boolean;
  isEditMode: boolean;
  showPosZoneMappingPopUp: boolean;
  isNonServiceable: boolean;
  posZoneSearchText: string;
  posZoneServiceRecord: any[]; // Replace with actual type of posZoneServiceRecord
  posZoneServiceFilteredRecord: any[]; // Replace with actual type of posZoneServiceFilteredRecord
  serviceTypeName: string;
  serviceRowIndex: string | number;
  mappingListRowIndex: string | number;
  mappingItemIndex: string | number;
  selectedPosZoneIndex: string;
  selectedPosZoneObj: Record<string, any>; // Replace with actual type of selectedPosZoneObj
  serviceTypeRecordList: ServiceTypeRecord[];
  // Mapping
  polygonIdsSearchTextValue: string;
  allPolygonListIdsRecord: string[];
  mappedPolygonIdsSearchTextValue: string;
  mappedPolygonIdsRecord: string[];
  // Polygon Details Pop Up
  openPolygonDetailsPopUp: boolean;
  polygonDetailsPopUpData: any;
  // Update Polygon Id
  polygonId: string | null;
}

export interface ServiceTypeRecord {
  name: string;
  multiPolygonEnabled?: boolean;
  displayName?: string;
  openAccordian: boolean;
  active: boolean;
  sameAsEarlier: boolean;
  enableConfigEdit: boolean;
  mappingList: MappingListInterface[];
}

export interface MappingListInterface {
  days: string[];
  mappings: MappingListItem[];
}

export interface MappingListItem {
  startTime: any;
  endTime: any;
  isNonServiceable: null | boolean;
  posId?: number | null;
  posNo?: string | null;
  posName?: string | null;
  zoneName?: string | null;
  zoneId?: number | string | null;
  serviceTypeId?: number | null;
  serviceType?: string | null;
  isChecked?: boolean;
  status?: string;
  // For Marketplace Shops we can have multiple POS zones mapped to a single startTime/endTime
  posZoneMappingArray?: MappingListPosZoneArray[];
  startTimeFromUpdate?: any;
  endTimeFromUpdate?: any;
  // Added other properties from PayloadPolygonMapping Interface for full compatibility
  polygonId?: string;
  lastModifiedAt?: string;
  lastModifiedBy?: string;
}

export interface MappingListPosZoneArray {
  startTime: any;
  endTime: any;
  isNonServiceable: null | boolean;
  posId?: number | null;
  posNo?: string | null;
  posName?: string | null;
  zoneName?: string | null;
  zoneId?: number | string | null;
  serviceTypeId?: number | null;
  serviceType?: string | null;
  isChecked?: boolean | null;
  status?: string | null;
  address?: string | null;
}

export const AppStateObj: AppStateObjInterface = {
  loading: false,
  isEditMode: false,
  //
  showPosZoneMappingPopUp: false,
  isNonServiceable: false,
  posZoneSearchText: "",
  posZoneServiceRecord: [],
  posZoneServiceFilteredRecord: [],
  serviceTypeName: "",
  serviceRowIndex: "",
  mappingListRowIndex: "",
  mappingItemIndex: "",
  selectedPosZoneIndex: "",
  selectedPosZoneObj: {},
  //
  serviceTypeRecordList: [],
  // Mapping
  polygonIdsSearchTextValue: "",
  allPolygonListIdsRecord: [],
  mappedPolygonIdsSearchTextValue: "",
  mappedPolygonIdsRecord: [],
  // Polygon Details Pop Up
  openPolygonDetailsPopUp: false,
  polygonDetailsPopUpData: {},
  // Update Polygon Id
  polygonId: null,
};

export interface ServiceTypeMapping {
  serviceType: string;
  serviceTypeId?: number;
  isServiceable: boolean;
  status?: string;
  posId?: string | number;
  posNo?: string;
  posName?: string;
  zoneName?: string;
  zoneId?: number;
  startTime: any;
  endTime: any;
}

export interface StoreDayWiseMapping {
  days: string[];
  mappings: ServiceTypeMapping[];
}

export interface ServiceTypeMappings {
  serviceType: string;
  storeDayWiseMappings: StoreDayWiseMapping[];
}
export interface PayloadObjectInterface {
  polygonIds: string[];
  changedServiceTypes: string[];
  serviceTypeMappings: ServiceTypeMappings[];
}

export interface PolygonServiceMappingInterface {
  polygonId: string;
  serviceTypeMappings: PolygonServiceMappingServiceTypeMapping[];
}

export interface PolygonServiceMappingServiceTypeMapping {
  serviceType: string;
  storeDayWiseMappings: PolygonServiceMappingStoreDayWiseMapping[];
}

export interface PolygonServiceMappingStoreDayWiseMapping {
  mappings: StoreMapping[];
}

export interface StoreMapping extends StoreMappingServiceableInterface {
  polygonId: string;
  isServiceable: boolean;
  startTime: string; // Format: "HH:mm:ss"
  endTime: string;   // Format: "HH:mm:ss"
  address?: string;
  posZoneMappingArray?: FlatStoreMapping[];
}

export interface StoreMappingServiceableInterface {
  posNo?: string | null;
  posName?: string | null;
  zoneName?: string | null;
  zoneId?: string | null;
  serviceType?: string;
  serviceTypeId?: number;
  status?: "ACTIVATED" | "DEACTIVATED";
  lastModifiedAt?: string; // Format: "DD-MMM-YYYY"
  lastModifiedBy?: string;
  address?: string;
}

// This is the flattened version of StoreMapping (without posZoneMappingArray)
export type FlatStoreMapping = Omit<StoreMapping, "posZoneMappingArray">;

export interface PolygonServiceRecordInterface {
  name: string;
  displayName?: string;
  id: string;
  multiPolygonEnabled?: boolean;
}

// Main Polygon Data Interface for the provided JSON structure
export interface PolygonListRecordInterface {
  polygonId: string;
  polygonName: string | null;
  serviceTypeMapping: {
    [serviceType: string]: Array<{
      id: number;
      posNo: string | null;
      posName: string | null;
      zoneId: string | null;
      zoneName: string | null;
      status: string | null;
      serviceTypeId: number;
      isServiceable: boolean;
      lastModifiedBy: string;
      lastModifiedAt: string;
    }>;
  };
  coordinates: Array<[number, number]>;
}

export interface PayloadPolygonMapping {
  polygonId: string;
  posNo: string | null;
  posName: string | null;
  zoneName: string | null;
  zoneId: string | null;
  serviceType: string;
  serviceTypeId: number;
  isServiceable: boolean;
  startTime: string;
  endTime: string;
  lastModifiedAt: string;
  lastModifiedBy: string;
}

export interface PolygonPopUpDetailsInterface {
  polygonId: string;
  serviceTypeRecordList: ServiceTypeRecord[];
  preSelectedServiceType?: string;
}